import { accessToken } from '../utils/helpers';
import https from '../utils/https';

type LinkAccountsBody = {
  amazonAccessToken: string;
  amazonId: string;
  displayName?: string;
};

const postLinkAccounts = async (req: LinkAccountsBody) => {
  const token = accessToken.get();

  const body = {
    access_token: req.amazonAccessToken,
    amazon_id: req.amazonId,
    display_name: req.displayName,
  };

  const resp = await https({ token }).post('/v1/external/amazon_prime_gaming/account/link', body);
  return resp.data;
};

type AccountStatusResp = {
  is_linked: boolean;
};

const postAccountStatus = async () => {
  const token = accessToken.get();
  const resp = await https({ token }).post<AccountStatusResp>('/v1/external/amazon_prime_gaming/account/status');
  return resp.data;
};

const externalApi = {
  postLinkAccounts,
  postAccountStatus,
};

export default externalApi;
